import * as authService from './services/authService';
import jwtDecode from 'jwt-decode';

const TOKEN_KEY = 'token';
let token = localStorage.getItem(TOKEN_KEY);

function saveToken(t) {
  token = t;
  localStorage.setItem(TOKEN_KEY, t);
}

function isTokenExpired(token) {
  if (!token) return true;
  try {
    const { exp } = jwtDecode(token);
    return Date.now() >= exp * 1000;
  } catch {
    return true;
  }
}

export function getToken() {
  if (isTokenExpired(token)) {
    removeToken();
  }
  return token;
}

function removeToken() {
  token = undefined;
  localStorage.removeItem(TOKEN_KEY);
}

export async function signIn(email, password) {
  const response = await authService.signIn(email, password);
  return response;
}

export async function validateOtp(email, otp) {
  const { token } = await authService.validateOtp(email, otp);
  saveToken(token);
  return _getUserInfo(token);
}

export async function signOut() {
  removeToken();
}

export function getUserInfo() {
  const token = getToken();
  if (token) return _getUserInfo(token);
  return null;
}

function _getUserInfo(token) {
  const { roleId, isActive, ...rest } = jwtDecode(token);
  return { roleId: parseInt(roleId), isActive: parseInt(isActive), ...rest };
}